import type { UIMessage } from "@convex-dev/agent";
import { getToolName, isToolUIPart } from "ai";

export type MessengerToolState = "running" | "done" | "failed";

/** One tool call of the agent; the server already stripped input and output. */
export interface MessengerToolStep {
  readonly id: string;
  readonly tool: string;
  readonly state: MessengerToolState;
}

/** Tool calls of one agent message, in call order. */
export function messengerToolSteps(parts: UIMessage["parts"]): MessengerToolStep[] {
  const steps: MessengerToolStep[] = [];
  for (const part of parts) {
    if (!isToolUIPart(part)) continue;
    let state: MessengerToolState;
    switch (part.state) {
      case "output-available":
        state = "done";
        break;
      case "output-error":
      case "output-denied":
        state = "failed";
        break;
      default:
        state = "running";
    }
    steps.push({ id: part.toolCallId, tool: getToolName(part), state });
  }
  return steps;
}
